import { FC } from 'react';

import { toNumberWithSpaces } from 'shared/lib/formatters';
import { IProductError } from 'entities/products/lib/checkProductToBuy';
import { IGoodInCart } from 'entities/products';
import type { ILocalOrderDelivery } from 'src/models/IOrder';
import CartItemChangeModal from '../Modal/CartItemChangeModal';
import { ImagesBlock } from './ImagesBlock';
import { InfoBlock } from './InfoBlock';
import styles from './styles.module.scss';

type Props = {
  price?: number;
  goods?: IGoodInCart[];
  orderWeight?: number;
  delivery?: ILocalOrderDelivery;
  liftPrice?: number;
  assemblyPrice?: number;
  isOrder?: boolean;
  isCheckoutDisabled?: boolean;
  onError?: () => void;
  productError?: IProductError;
  setProductError?: (setProductError) => void;
};

const CartSidebar: FC<Props> = ({
  price,
  goods,
  orderWeight,
  isOrder = false,
  productError,
  setProductError,
  onError,
}) => {
  const { numberGoods, priceWithoutDiscount } = goods.reduce(
    (acc, good) => {
      if (good.isRemoved || !good.isChecked) {
        return acc;
      }
      return {
        numberGoods: acc.numberGoods + good.quantity,
        priceWithoutDiscount: acc.priceWithoutDiscount + good.list_price,
      };
    },
    {
      numberGoods: 0,
      priceWithoutDiscount: 0,
    }
  );

  const handleCloseErrorModal = () => {
    onError && onError();
    setProductError && setProductError(null);
  };

  return (
    <>
      {!!productError && (
        <CartItemChangeModal
          onClose={handleCloseErrorModal}
          description={productError.description}
          title={productError.title}
        />
      )}

      <div className={`${styles.cartSidebar} ${isOrder ? styles.cartFormSidebar : ''}`}>
        <h3>Ваш заказ</h3>
        {isOrder && <ImagesBlock goods={goods} />}
        <InfoBlock
          sellerDiscount={priceWithoutDiscount - price}
          numberGoods={numberGoods}
          priceWithoutDiscount={priceWithoutDiscount}
          orderWeight={orderWeight}
        />
        <div className={styles.cartSidebarTotal}>
          <div>
            <span>Итого</span> <span>{toNumberWithSpaces(price)} ₽</span>
          </div>
          <p>Без учёта возможной стоимости доставки</p>
        </div>
      </div>
    </>
  );
};
export default CartSidebar;
